import { DsTypography } from '@ice-web-app/designSystem';
// Week Toggle Component - SAT V4 Zone
import { Box, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { FC } from 'react';

export type WeekType = 'A' | 'B';

interface WeekToggleProps {
  selectedWeek: WeekType;
  onChange: (week: WeekType) => void;
  label?: string;
}

export const WeekToggle: FC<WeekToggleProps> = ({ selectedWeek, onChange, label = 'View Week' }) => {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newWeek: WeekType | null) => {
    if (newWeek !== null) {
      onChange(newWeek);
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <DsTypography variant="body2" color="text.secondary">
          {label}:
        </DsTypography>
        <ToggleButtonGroup
          value={selectedWeek}
          exclusive
          onChange={handleChange}
          size="small"
          aria-label="week selection"
        >
          <ToggleButton
            value="A"
            aria-label="Week A"
            sx={{
              '&.Mui-selected': {
                bgcolor: 'primary.main',
                color: 'white',
                '&:hover': {
                  bgcolor: 'primary.main',
                },
              },
              '&:hover': {
                bgcolor: 'transparent',
              },
            }}
          >
            Week A
          </ToggleButton>
          <ToggleButton
            value="B"
            aria-label="Week B"
            sx={{
              '&.Mui-selected': {
                bgcolor: 'primary.main',
                color: 'white',
                '&:hover': {
                  bgcolor: 'primary.main',
                },
              },
              '&:hover': {
                bgcolor: 'transparent',
              },
            }}
          >
            Week B
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Box>
  );
};

export default WeekToggle;
